import React, { useEffect, useState } from 'react';
import { chatAPI } from './api';

const TestAPI = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    testAPI();
  }, []);

  const testAPI = async () => {
    try {
      const response = await chatAPI.getTraders();
      console.log('Full Response:', response);
      console.log('Response.data:', response.data);
      console.log('Is Array?', Array.isArray(response.data));
      console.log('Length:', response.data?.length);
      setData(response.data);
    } catch (err) {
      console.error('Error:', err);
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>API Test</h2>
      {error && <p style={{color: 'red'}}>Error: {error}</p>}
      {data && (
        <div>
          <p>Data Type: {Array.isArray(data) ? 'Array' : typeof data}</p>
          <p>Length: {data.length}</p>
          <pre>{JSON.stringify(data[0], null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default TestAPI;
